import connectStyle from './src/connectStyle';
import { INCLUDE } from './src/resolveIncludes';
import StyleProvider from './src/StyleProvider';
import Theme, { ThemeShape } from './src/Theme';
import { createVariations, createSharedStyle } from './src/addons';


export {
  connectStyle,
  INCLUDE,
  StyleProvider,
  Theme,
  ThemeShape,
  createVariations,
  createSharedStyle,
};



// WEBPACK FOOTER //
// ./node_modules/native-base-shoutem-theme/index.js